export function ezfToUpperOnKeyDown(event, e) {
  let keyCode = event.keyCode;
  // F1 - F12
  if (keyCode >= 112 && keyCode <= 123) {
    _ezfToUpperOnBlur(e);
  }
}

export function ezfToUpperOnBlur(e) {
  setTimeout(function () {
    _ezfToUpperOnBlur(e);
  }, 25);
}

function _ezfToUpperOnBlur(e) {
  if (e.value) {
    e.value = e.value.toUpperCase();
  }
}
